import React from "react";

const FeatureBanner = () => {
  return (
    <div className="grid gap-4 grid-cols-2 lg:grid-cols-4 bg-[#F3F3F3] p-6 mb-6">
      <div className="flex flex-col gap-2 items-center">
        <img
          src="https://d1lfl311x81a6w.cloudfront.net/Static_images/fet2.png"
          alt="fet2"
          loading="lazy"
          className="w-[40px] h-[40px]"
        />
        <h3 className="text-center text-[12px] font-semibold">
          Pure Sterling Silver Used
        </h3>
      </div>
      <div className="flex flex-col gap-2 items-center">
        <img
          src="https://d1lfl311x81a6w.cloudfront.net/Static_images/BIS-Hallmark-Black.png"
          alt="fet4"
          loading="lazy"
          className="w-[40px] h-[40px]"
        />
        <h3 className="text-center text-[12px] font-semibold">
          BIS Hallmarked Jewellery
        </h3>
      </div>
      <div className="flex flex-col gap-2 items-center">
        <img
          src="https://d1lfl311x81a6w.cloudfront.net/Static_images/fet1.png"
          alt="fet1"
          loading="lazy"
          className="w-[40px] h-[40px]"
        />
        <h3 className="text-center text-[12px] font-semibold">
          3 Months 18K Plating Warranty
        </h3>
      </div>
      <div className="flex flex-col gap-2 items-center">
        <img src="/certificate.png" alt="fet1" className="w-[40px] h-[40px]" loading="lazy" />
        <h3 className="text-center text-[12px] font-semibold">
          Authentication Certificate
        </h3>
      </div>
    </div>
  );
};

export default FeatureBanner;
